export default __webpack_public_path__ + "static/media/blueprint.36acc607.jpeg";